import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { AdminProductDataSourceService } from '../../services/admin-product-data-source.service';
import { once } from '@web/utils';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminProductDetailsForm } from '../../models/admin-product-details-form';
import { AdminProductDetailsFormComponent } from '../admin-product-details-form/admin-product-details-form.component';

@Component({
  selector: 'app-admin-product-create',
  imports: [AlertsComponent, AdminProductDetailsFormComponent],
  templateUrl: './admin-product-create.component.html',
  styleUrl: './admin-product-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminProductCreateComponent {
  private readonly productDataSource = inject(AdminProductDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(data: AdminProductDetailsForm): void {
    this.productDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => this.notifySubmitSuccessEvent(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
